// TennisTrack Hub — API Helper | 029 Project
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

// Inietta token automaticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tt_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Gestione errore 401 (token scaduto)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('tt_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
